import { isWeb } from 'tamagui';

export const hitSlop = (padding: number) => {
    return isWeb
        ? {}
        : {
              hitSlop: {
                  top: padding,
                  right: padding,
                  bottom: padding,
                  left: padding,
              },
          };
};

export const borderCurve = (
    borderCurve: 'unset' | 'circular' | 'continuous' | undefined,
) => {
    return isWeb
        ? {}
        : {
              borderCurve,
          };
};
